import { useLocation } from 'react-router-dom';
import { getStoredFlow, setStoredFlow } from '../services/storage';

export type FlowType = 'Kit Keeper' | 'Keepr' | 'St Annes';

export const useFlow = (): FlowType => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowParam = searchParams.get('flow');

  if (flowParam === 'keepr') {
    setStoredFlow('Keepr');
    return 'Keepr';
  } else if (flowParam === 'kitkeeper') {
    setStoredFlow('Kit Keeper');
    return 'Kit Keeper';
  } else if (flowParam === 'stannes') {
    setStoredFlow('St Annes');
    return 'St Annes';
  }

  return getStoredFlow() ?? 'Kit Keeper';
};
